export default __webpack_public_path__ + "static/media/es-ml.01c7594e.svg";